import { MAX_DESCRIPTION_CHARACTERS } from '@uturn/portal/components/file-dropzone';
import { z } from '@uturn/portal/zod';
import {
	addIssueRequired,
	getRequiredFields,
	RequiredField,
} from '@uturn/portal/zod/utils';

/** @see FileUploadRequest — document upload form. */
const documentUploadObjectSchema = z.object({
	file: z.instanceof(File, { message: 'required' }).describe(RequiredField),
	typeCode: z.string().describe(RequiredField),
	description: z
		.string()
		.max(MAX_DESCRIPTION_CHARACTERS)
		.describe(RequiredField),
});

export const documentUploadSchema = documentUploadObjectSchema.superRefine(
	(values, ctx) => {
		if (!values.typeCode) {
			addIssueRequired(ctx, 'typeCode');
		}
		if (!values.description) {
			addIssueRequired(ctx, 'description');
		}
	},
);

export type DocumentUploadFormValues = z.infer<typeof documentUploadSchema>;

export const documentUploadRequiredFields = getRequiredFields(
	documentUploadObjectSchema,
);
